import React from "react";

export default function FileMessage({ msg }) {
  const url = msg.file?.url || "";
  const name = msg.file?.name || "文件";
  return (
    <div
      className="imc-bubble imc-bubble-file"
      onClick={() => url && window.open(url, "_blank")}
    >
      <span className="imc-file-icon">📎</span>
      <span className="imc-file-name">{name}</span>
    </div>
  );
}
